import { Directive, input, output } from '@angular/core';

@Directive({
  selector: '[swipeNavigation]',
  standalone: true,
  host: {
    '[style.touch-action]': "enabled() ? 'pan-y pinch-zoom' : null",
    '(touchstart)': 'onTouchStart($event)',
    '(touchend)': 'onTouchEnd($event)',
    '(touchcancel)': 'onTouchCancel()'
  }
})
export class SwipeNavigationDirective {
  readonly enabled = input(true, { alias: 'swipeNavigation' });
  readonly onSwipeLeft = output<void>();
  readonly onSwipeRight = output<void>();

  private touchStart: { id: number; x: number; y: number } | null = null;

  onTouchStart(event: TouchEvent): void {
    const touch = event.touches[0];
    this.touchStart =
      this.enabled() && event.touches.length === 1
        ? { id: touch.identifier, x: touch.clientX, y: touch.clientY }
        : null;
  }

  onTouchEnd(event: TouchEvent): void {
    const start = this.touchStart;
    this.touchStart = null;
    if (!start || !this.enabled() || event.touches.length) {
      return;
    }
    const touch = Array.from(event.changedTouches).find(item => item.identifier === start.id);
    if (!touch) {
      return;
    }
    const movedBy = touch.clientX - start.x;
    if (Math.abs(movedBy) < 48 || Math.abs(movedBy) <= Math.abs(touch.clientY - start.y) * 1.5) {
      return;
    }

    if (movedBy < 0) {
      this.onSwipeLeft.emit();
    } else {
      this.onSwipeRight.emit();
    }
  }

  onTouchCancel(): void {
    this.touchStart = null;
  }
}
